import React from 'react'
import Comments from '../../comments/Comments'

const TabComments = ({ comments, supplyOrderId, supplyBillId, supplierId, writeOffActId }) => {
  return (
    <div className='addTabs__comments'>
        <Comments
			comments={comments}
			supplyOrderId={supplyOrderId}
			supplyBillId={supplyBillId}
			supplierId={supplierId}
			writeOffActId={writeOffActId}
		/>
    </div>
  )
}

export default TabComments